import type { SortState } from './search-state'

/**
 * The order after a press on a column's header, stepped as the mockups' `lib/sorting.js` steps it:
 * a column not sorted joins the end of the order ascending, an ascending one turns descending in
 * place, and a descending one leaves the order, the columns after it moving up. With `together`,
 * the fields the column sorts with, it joins the order only when every column already in it is
 * one of them; otherwise, as on a screen that sorts by one column, it starts the order afresh.
 */
export function nextSorts(sorts: readonly SortState[], field: string, together: readonly string[] | null): readonly SortState[] {
  const at = sorts.findIndex((sort) => sort.field === field)
  if (at < 0) {
    const joins = together !== null && sorts.every((sort) => together.includes(sort.field))
    return joins ? [...sorts, { field, descending: false }] : [{ field, descending: false }]
  }
  return sorts[at]?.descending === true
    ? sorts.filter((_, index) => index !== at)
    : sorts.map((sort, index) => (index === at ? { field, descending: true } : sort))
}
